// import { navigate } from "wouter/use-browser-location";
import {
  jsonDelete,
  jsonGet,
  jsonPost,
  jsonPut,
  prefix,
  // getProfile,
} from "../api";
// import { useStore } from "../../store"; // HACK!

// AUTH
export async function requestPasswordReset(dto) {
  return await jsonPost("auth/account/forgot-password", dto);
}

export async function changePassword(dto) {
  return await jsonPost("auth/account/change-password", dto);
}

export async function setPassword(dto) {
  return await jsonPut("auth/account/password", dto);
}

export async function userRegister(dto) {
  return await jsonPost("auth/account/register", dto);
}

export async function deleteUserSession(sessionId) {
  return await jsonDelete(`auth/account/sessions/${sessionId}`);
}

export async function login(dto) {
  var response = await fetch(`${prefix}/auth/login`, {
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams(dto),
  });

  if (!response.ok) {
    // Surface a machine-readable code when the server sends one (e.g. "passkey_required" when the
    // tenant mandates passkey sign-in) so the login form can steer the user instead of showing a
    // generic "incorrect password".
    let code = null;
    try {
      code = (await response.json())?.code ?? null;
    } catch {
      /* non-JSON error body */
    }
    const message = `A login error has occured: ${response.status}`;
    const error = new Error(message, { cause: response.status });
    error.code = code;
    throw error;
  }

  var data = await response.json();
  return data;
}

export async function loginWithToken(token) {
  return await jsonPost("auth/token", { token });
}

export async function userConfirmation(dto) {
  return await jsonPost("auth/account/confirmation", dto);
}

export const fetchInvite = async (token) =>
  await jsonGet(`invitations/${token}`);

// export const fetchKeys = async () => await jsonGet("auth/passkey/keys");

export const registerKey = async () =>
  await jsonPost("auth/passkey/register/begin");
export const completeKeyRegistration = async (dto) =>
  await jsonPost("auth/passkey/register/complete", dto);
